<div class="card m-0 bg-transparent">
  <div class="card-body">
    <form [formGroup]="labelform">
      <div class="row d-flex justify-content-between align-items-center mb-3">
        <div class="col-12 m-0">
          <label
            for="text-color"
            class="offcanvas-header-text w-100"
            style="text-align: left"
          >
            Use as Profile
          </label>
          <select
            id="selectoption"
            class="form-select offcanvas-primary ng-pristine ng-valid ng-touched border-0 shadow-none"
            formControlName="use"
            (change)="onSelectChange()"
          >
            <option [value]="''">Select</option>
            <option *ngIf="showFileds.includes('name')" [value]="'name'">Name</option>
            <option *ngIf="showFileds.includes('image')" [value]="'image'">Image</option>
          </select>
        </div>
      </div>
    </form>
  </div>
</div>
